import {
  axiosInstance,
  USER_UPDATE_URL,
  GET_PREFERENCE_URL,
} from "../apiurls/apiurls";

export const updateUserPreference = async (payload) => {
  try {
    const response = await axiosInstance.put(USER_UPDATE_URL, payload);
    return response.data;
  } catch (error) {
    console.error("updateUserPreference error:", error);
    throw error;
  }
};

export const getPreferenceData = async () => {
  try {
    const response = await axiosInstance.get(GET_PREFERENCE_URL);
    return response.data;
  } catch (error) {
    console.error("updateUserPreference error:", error);
    throw error;
  }
};
